import { useEffect, useState } from "react";
import { PipelineList } from "../../components/specific/pipeline/PipelineList";
import { getPipelines } from "../../api/pipelineMaintenance/api";
import { Pipeline } from "../../types/domain";
import { MaintenanceSection, MaintenanceSectionContent, MaintenanceSectionHeader } from "../../components/layout/maintenance";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@/components/shadcn/button";

export const PipelineMaintenancePage = () => {
  const navigate = useNavigate();

  const [pipelines, setPipelines] = useState<Pipeline[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  
  const fetchPipelines = async () => {
    try {
      setIsLoading(true);
      setPipelines(await getPipelines());
    } catch (err) {
      console.error("Error fetching pipelines: ", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchPipelines();
  }, []);
  
  return (
    <>
      <MaintenanceSection>
        <MaintenanceSectionHeader title={Translation.PipelineMaintenance.headerPipelines}>
          <Button variant={"outline"} size={"sm"} title="Create a new Pipeline" onClick={() => navigate("/PipelineMaintenance/CreatePipeline")}>
            {<FontAwesomeIcon icon={faPlus} />}
            {"Create Pipeline"}
          </Button>
        </MaintenanceSectionHeader>
        <MaintenanceSectionContent>
          <PipelineList pipelines={pipelines} onPipelineDeleted={fetchPipelines} isLoading={isLoading} />
        </MaintenanceSectionContent>
      </MaintenanceSection>
    </>
  );
};
